import React from 'react';
import '../index.css';

const Footer = () => {
  return (
    <footer>
      Made by <a href='https://www.linkedin.com/in/aashxx/' style={{color: '#673ab7', textDecoration: 'none'}}><strong>Mohamed Aashir</strong></a>
    </footer>
  )
}

export default Footer
